/**
 * @generated SignedSource<<9167f2621e6cf106559738ba6aef7b0e>>
 * @relayHash e24366c26db43cec71d2389d47713237
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentCreationLocation = "DATABASE" | "EDITOR" | "LIVE" | "RENDERER" | "WHITEBOARD" | "%future added value";
export type ContentRepresentation = "ATLAS_DOC_FORMAT" | "EDITOR" | "EDITOR2" | "EXPORT_VIEW" | "PLAIN" | "RAW" | "STORAGE" | "STYLED_VIEW" | "VIEW" | "WIKI" | "%future added value";
export type Platform = "ANDROID" | "IOS" | "WEB" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CreateInlineCommentInput = {
  commentBody: CommentBody;
  commentSource?: Platform | null | undefined;
  containerId: string;
  createdFrom: CommentCreationLocation;
  lastFetchTimeMillis: AGG$Long;
  matchIndex: number;
  numMatches: number;
  originalSelection: string;
  parentCommentId?: string | null | undefined;
  publishedVersion?: number | null | undefined;
  step?: Step | null | undefined;
};
export type CommentBody = {
  representationFormat: ContentRepresentation;
  value: string;
};
export type Step = {
  from?: AGG$Long | null | undefined;
  mark: Mark;
  pos?: AGG$Long | null | undefined;
  to?: AGG$Long | null | undefined;
};
export type Mark = {
  attrs?: MarkAttribute | null | undefined;
  type: string;
};
export type MarkAttribute = {
  annotationType: string;
  id: string;
};
export type useCreateInlineCommentMutation$variables = {
  input: CreateInlineCommentInput;
  pageId: string;
};
export type useCreateInlineCommentMutation$data = {
  readonly createInlineComment: {
    readonly author: {
      readonly __typename: string;
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly permissionType: SitePermissionType | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
      readonly type: string | null | undefined;
    };
    readonly body: {
      readonly value: string;
    };
    readonly container: {
      readonly id: string | null | undefined;
    };
    readonly contentStatus: string;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null | undefined;
      readonly webui: string | null | undefined;
    };
    readonly location: {
      readonly __typename: string;
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineMarkerRef?: string | null | undefined;
      readonly inlineResolveProperties?: {
        readonly isDangling: boolean;
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineText?: string | null | undefined;
      readonly type: string;
    };
    readonly parentId: string | null | undefined;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly reactionsSummary: {
      readonly ari: string;
      readonly containerAri: string;
      readonly reactionsCount: number;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number;
        readonly emojiId: string;
        readonly id: string;
        readonly reacted: boolean;
      } | null | undefined>;
    } | null | undefined;
    readonly version: {
      readonly by: {
        readonly __typename: string;
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly friendlyWhen: string | null | undefined;
      readonly number: number | null | undefined;
      readonly when: string | null | undefined;
    };
  } | null | undefined;
};
export type useCreateInlineCommentMutation = {
  response: useCreateInlineCommentMutation$data;
  variables: useCreateInlineCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v9 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v10 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v11 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v12 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Comment",
    "kind": "LinkedField",
    "name": "createInlineComment",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "permissionType"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          },
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "representation",
            "value": "ATLAS_DOC_FORMAT"
          }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "contentStatus"
      },
      {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": (v7/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
      },
      {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "editui"
          },
          {
            "kind": "ScalarField",
            "name": "webui"
          }
        ]
      },
      {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              }
            ],
            "type": "FooterComment"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
              },
              {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isDangling"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "inlineText"
              }
            ],
            "type": "InlineComment"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "parentId"
      },
      {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEditable"
          },
          {
            "kind": "ScalarField",
            "name": "isRemovable"
          },
          {
            "kind": "ScalarField",
            "name": "isResolvable"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "childType",
            "value": "comment"
          },
          {
            "kind": "Literal",
            "name": "contentType",
            "value": "page"
          },
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
          }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ari"
          },
          {
            "kind": "ScalarField",
            "name": "containerAri"
          },
          {
            "kind": "ScalarField",
            "name": "reactionsCount"
          },
          {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "kind": "ScalarField",
                "name": "emojiId"
              },
              {
                "kind": "ScalarField",
                "name": "reacted"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "friendlyWhen"
          },
          {
            "kind": "ScalarField",
            "name": "number"
          },
          {
            "kind": "ScalarField",
            "name": "when"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCreateInlineCommentMutation",
    "selections": (v12/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreateInlineCommentMutation",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "e24366c26db43cec71d2389d47713237",
    "id": "6fb8d32a19fd54f1167b17c440131031a9406832544a4743963e9e462353f885",
    "metadata": {},
    "name": "useCreateInlineCommentMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateInlineCommentMutation($pageId:ID!,$input:CreateInlineCommentInput!){createInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
  }
};
})();

(node as any).hash = "f3ea5340b40a0a0dd635fcfbf3e8ed68";

export default node;
